import React from 'react'

/**
 * Componente para mostrar la política de cookies (Contenido estático)
 *
 * @component
 */

export const CookiesPolicy = (props) => {
  return (
    <div id="cookiesPolicy">
      <div className="container-fluid padding-fluid">
        <h3>POLÍTICA DE COOKIES</h3>
        <br></br>
        <br></br>
        <p>
          Una cookie es un pequeño archivo que se descarga en el equipo del
          usuario (computadora, laptop, smartphone, tablet, etc.) cuando accede
          a determinadas páginas web, este archivo almacena y recupera
          información sobre la navegación que se efectúa desde dicho equipo. Si
          tiene dudas sobre el uso de cookies por parte de ANALYTIC NEWS
          MONITOREO DE MEDIOS (RAM), puede contactar a{' '}
          <a href="mailto:delegadodatos_ram@rangle.ec">
            delegadodatos_ram@rangle.ec
          </a>
          <br></br>
          <br></br>
          <b>TIPOS DE COOKIES UTILIZADAS Y FINALIDADES</b>
          <br></br>
          Los tipos de cookies que utilizamos están categorizados como:<br></br>
          Estrictamente necesarias: son aquéllas necesarias para la operación
          del sitio web, garantizan el correcto funcionamiento de este y la
          utilización de las diferentes opciones o servicios que lo componen.
          Son cookies que permiten, por ejemplo, identificar la sesión, acceder
          a partes de acceso restringido, recordar los elementos que integran un
          pedido, realizar el proceso de compra, gestionar el pago, almacenar
          contenidos para la difusión de vídeos o sonido, habilitar contenidos
          dinámicos (por ejemplo, animación de carga de un texto o imagen) o
          compartir contenidos a través de redes sociales. Si se desactivan
          estas cookies, no podrá obtener la funcionabilidad del sitio web total
          o parcialmente. Complementarias: son aquéllas que almacenan
          información no necesaria para el funcionamiento del sitio web pero que
          permiten habilitar funcionalidades adicionales. Con ello se posibilita
          la gestión, de la forma más eficaz posible, de los espacios
          publicitarios y el contenido del sitio web según el perfil específico
          del usuario.
          <br></br>
          <br></br>
          En particular, se utilizan cookies complementarias con la finalidad
          de:<br></br>· Mejorar el Rendimiento: Cookies para recoger información
          anónima sobre el uso de la página web. Esta información ayuda a
          mejorar nuestra web y nos ayuda a entender la efectividad de esta. En
          algunos casos, utilizamos servicios de terceras partes de confianza
          como Google Analytics y Hotjar para recoger dicha información, pero
          solo la utilizan para los fines previamente descritos. ·
          Funcionalidad: Cookies se utilizan para proveer servicios o recordar
          ajustes para mejorar su experiencia, por ejemplo, utilizar su
          dirección IP para identificar accesos no autorizados al sistema. ·
          Focalización y publicidad: Estas cookies son utilizadas por terceras
          partes de confianza para publicitar anuncios que se adapten a sus
          intereses. También se utilizan para limitar el número de veces que ve
          un anuncio y para medir la efectividad de las campañas publicitarias.
          La información contenida en dichas cookies es anónima y no contiene
          información de carácter personal. "<br></br>
          <br></br>
          <b>ADMINISTRACIÓN DE COOKIES</b>
          <br></br>
          Puede desactivar las cookies especificas sin que afecte al
          funcionamiento del sitio web (cookies complementarias); sin embargo,
          la información captada por estas cookies sobre el uso de nuestra web
          puede afectar el funcionamiento adicional. El usuario podrá elegir qué
          cookies quiere que funcionen en este sitio web mediante:
          <br></br>
          <br></br>
          ·La configuración del navegador; por ejemplo:<br></br>
          ·Chrome, desde{' '}
          <a href="https://support.google.com/chrome/answer/95647?hl=es">
            https://support.google.com/chrome/answer/95647?hl=es
          </a>
          <br></br>
          ·Explorer, desde{' '}
          <a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies">
            https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies
          </a>
          <br></br>
          ·Firefox, desde{' '}
          <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias?redirectslug=habilitar-y-deshabilitar-cookies-que-los-sitios-we&redirectlocale=es">
            https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias?redirectslug=habilitar-y-deshabilitar-cookies-que-los-sitios-we&redirectlocale=es
          </a>
          <br></br>
          <br></br>
          Asimismo, el usuario puede activar en su navegador web:<br></br>
          ·La navegación privada, mediante la cual su navegador deja de guardar
          el historial de navegación, contraseñas de sitios web, cookies y otra
          información de las páginas que visita.
          <br></br>
          <br></br>
          ·La función de no rastrear, por la que el navegador pide a los sitios
          web que visita que no rastreen sus hábitos de navegación para, por
          ejemplo, servirle publicidad de su interés en los sitios que visita.
        </p>
      </div>
    </div>
  )
}
